import ChatInput from "./ChatInput";
import LoadingSpinner from "./LoadingSpinner";
import { cn } from "app/lib/utils";

interface Props {
  readonly loadingMessage?: string;
  readonly subMessage?: string;
  readonly showInput?: boolean;
  readonly className?: string;
}

export default function ChatLoadingState({
  loadingMessage = "Please wait, Coach Bo is loading...",
  subMessage = "This will take less than a minute.",
  showInput = true,
  className = "",
}: Readonly<Props>) {
  return (
    <div
      className={cn(
        "flex flex-col h-full py-6 max-w-[768px] mx-auto",
        className
      )}
    >
      {/* Main loading content - takes all available space and centers content */}
      <div className="flex flex-col items-center justify-center text-center flex-grow">
        <LoadingSpinner message={loadingMessage} subMessage={subMessage} />
      </div>

      {/* Bottom section with disabled input */}
      {showInput && (
        <div className="flex flex-col gap-4">
          <ChatInput disabled />
        </div>
      )}
    </div>
  );
}
